<div
  class="box-border flex w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }"
  [ngStyle]="{
    backgroundColor: inputBackground(),
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div class="rounded-input relative w-full bg-inherit">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="ngControl.control! | toFormControl"
      (focus)="isFocused.set(true)"
      (blur)="isFocused.set(false)"
      class="border-input-ring border-input rounded-input peer p-input w-full bg-transparent placeholder-transparent focus:ring-0"
      [ngClass]="{
        'border-input-error focus:border-input-focus': hasError,
        'border-input-ring focus:border-input-focus': !hasError,
        'pointer-events-none': ngControl.disabled,
      }"
      [ngStyle]="{
        borderRadius: borderRounding(),
        borderColor: borderAndLabelColor(),
        color: corporateDesignService.fontColor(),
      }"
      [id]="id()"
      [placeholder]="label() ?? ''"
      [type]="isPasswordVisible() ? 'text' : 'password'" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 mx-1 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit px-1 text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:max-h-6 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [ngClass]="{
        'text-input-error': hasError,
      }"
      [ngStyle]="{
        color: borderAndLabelColor(),
      }"
      [for]="id()">
      {{ formattedLabel() }}
    </label>

    @if (!ngControl.control!.disabled) {
      <span
        tabindex="0"
        [id]="id() | appendTestId: 'visibility-switch'"
        [attr.data-testid]="id() | appendTestId: 'visibility-switch'"
        [attr.aria-label]="isPasswordVisible() ? 'sichtbar' : 'nicht sichtbar'"
        class="material-symbols-rounded text-input-label absolute top-3 right-4 bottom-1 h-8 cursor-pointer text-2xl"
        (click)="isPasswordVisible.set(!isPasswordVisible())">
        {{ isPasswordVisible() ? 'visibility_off' : 'visibility' }}
      </span>
    }
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
